import { useEffect, useState } from "react";
import { useNotification } from "../../context/notification";
import NotesInputGroup from "../NotesInputGroup";
import NotesList from "../NotesList";
import styles from "./index.module.scss";

import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import { useTranslation } from "react-i18next";
import { SessionStatus } from "../../config/Config";
import { apiRequest } from "../../utils/api";
import { getLocalValue } from "../../utils/auth";

export default function NotesSidebar({
  sessionID,
  isCoach, // defines whether the current user is a coach(true) or coachee(false)
  accessible,
  hasAchievedKPICompliment,
  ...props
}) {
  const { t } = useTranslation();
  const [list, setList] = useState([]);
  const { addNotification } = useNotification();
  const [sessionData, setSessionData] = useState({});
  const [subjectData, setSubjectData] = useState({});
  const [hasAchievedKPI, setHasAchievedKPI] = useState(false); // Initialize hasAchievedKPI

  const fetchSessionNotes = async function () {
    const response = await apiRequest
      .get(`/api/getSessionNotes?session_id=${sessionID}`)
      .catch((error) => { });

    if (response.data && response.data.data && response.data.data.notes) {
      const notes = response.data.data.notes;
      let newNoteList = [];
      notes.forEach((note) => {
        note.type_id = note.note_category_id;
        newNoteList.push({
          id: note.note_id, // random counter value
          type_id: note.type_id,
          note: note.note,
          like: note.liked_by_coach || note.liked_by_coachee,
          author: note.note_created_user,
          author_id: note.note_created_user_id,
          liked_by_coach: note.liked_by_coach,
          liked_by_coachee: note.liked_by_coachee,
          note_created_at: note.note_created_at
        });
      });
      setList(newNoteList);
    }
  };

  const fetchSessionData = async () => {
    // Fetch session data
    // After fetching session data, calculate hasAchievedKPI
    const response = await apiRequest.get(`/api/getSessionDetails?session_id=${sessionID}`);
    if (response.status === 200) {
      const data = response.data.data;
      setSessionData(data.session);
      setSubjectData(data.subject);
      const isKpiPassed = data.subject.some(subject => subject.kpi_status === 'Pass');
      const hasAchieved = isKpiPassed && data.session.status !== SessionStatus.PROGRESSING;
      setHasAchievedKPI(hasAchieved);
    }
  };

  const getSessionValue = (field) => {
    return sessionData ? sessionData[field] : undefined;
  };

  // fetch session notes on first render
  useEffect(() => {

    fetchSessionNotes();
    fetchSessionData();
  }, []);

  const handleSend = (text, noteTypeObj, successCallback) => {
    let sessionNotesObj = {
      session_id: sessionID,
      note_category_id: noteTypeObj.type_id,
      note: text,
      user_type: getLocalValue("u_role"),
      created_by: getLocalValue("uid"),
      liked_by_coach: 0, // messages are unliked by default
      liked_by_coachee: 0,
    };
    apiRequest
      .post(`/api/createSessionNotes`, sessionNotesObj)
      .then((resp) => {
        if (resp.status === 200) {
          fetchSessionNotes();
          successCallback(true);
        } else if (resp.status === 400) {
          addNotification(
            t(resp.data.error, { property: resp.data.property }),
            "error"
          );
        }
      })
      .catch((error) => {
        addNotification(`${error}`, "error");
      })
      .finally(() => { });
  };

  const handleLike = (id, newVal) => {
    let myUID = parseInt(getLocalValue("uid"));
    let sessionCoach = parseInt(getSessionValue("coach_id"));
    let sessionCoachee = parseInt(getSessionValue("coachee_id"));
    // only able to like/unlike if the user is either the designated coach or coachee
    let ableToInteract = myUID === sessionCoach || myUID === sessionCoachee;
    if (ableToInteract) {
      let params = {};
      if (isCoach) {
        params.liked_by_coach = newVal;
      } else {
        params.liked_by_coachee = newVal;
      }
      apiRequest.patch(`/api/updateNoteLikes/${id}`, { ...params });
    } else {
      addNotification(
        `You can only like notes as the session's designated coach or coachee.`,
        "warning"
      );
    }
  };

  return (
    <>
      <div className={styles.header}>{t("createSession.notes")}</div>
      {hasAchievedKPI && hasAchievedKPICompliment === true && (
        <div className={styles.notificationBanner}>
          <span style={{ fontSize: "14px", lineHeight: "1", opacity: "1", textAlign: "left" }}><strong>{sessionData.coachee_name}</strong> has achieved the Project Target KPI! Recognize their achivement with a Compliment
            <EmojiEventsIcon style={{ verticalAlign: "middle", color: "#FF9C12" }} /></span>

        </div>
      )}
      {accessible === true && (
        <>
          <NotesInputGroup handleSend={handleSend} hasAchievedKPI={hasAchievedKPI} hasAchievedKPICompliment={true} />
        </>
      )}
      <NotesList
        handleLike={handleLike}
        list={list}
        setList={setList}
        canLike={accessible}
      />
    </>
  );
}